import React from 'react';
import CapabilitiesPageReview from './CapabilitiesPageReview';
import StandardQuestionsPageReview from './StandardQuestionsPageReview';

function PageReview(props) {
  switch (props.page.type) {
    case 'standard-questions':
      return <StandardQuestionsPageReview {...props} />;
    default:
      return <CapabilitiesPageReview {...props} />;
  }
}

export default PageReview;
